var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDollarCircle = function SvgDollarCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08317 11.7222C6.08317 12.7961 6.95373 13.6667 8.02762 13.6667H9.83317C10.9838 13.6667 11.9165 12.7339 11.9165 11.5833C11.9165 10.4327 10.9838 9.49999 9.83317 9.49999H8.1665C7.01591 9.49999 6.08317 8.56725 6.08317 7.41666C6.08317 6.26606 7.01591 5.33332 8.1665 5.33332H9.97206C11.0459 5.33332 11.9165 6.20388 11.9165 7.27777M8.99984 4.08332V5.33332M8.99984 13.6667V14.9167M17.3332 9.49999C17.3332 14.1024 13.6022 17.8333 8.99984 17.8333C4.39746 17.8333 0.666504 14.1024 0.666504 9.49999C0.666504 4.89762 4.39746 1.16666 8.99984 1.16666C13.6022 1.16666 17.3332 4.89762 17.3332 9.49999Z",
    stroke: "#2D4C5D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDollarCircle;